import React from 'react';
import { Layers } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';

const MapLayerToggle = ({ layers, onChange }) => {
  const { language } = useLanguage();
  const isArabic = language === 'ar';

  const items = [
    { key: 'projects',        label: isArabic ? 'المشاريع' : 'Projects',         color: '#2FAE8F', enabled: true },
    { key: 'successStories',  label: isArabic ? 'قصص النجاح' : 'Success Stories', color: '#E8A838', enabled: true },
    { key: 'outlets',         label: isArabic ? 'منافذ البيع' : 'Sales Outlets',   color: '#4A8AC0', enabled: false },
    { key: 'jada30',          label: isArabic ? 'جادة 30' : 'Jada 30',             color: '#D6A84F', enabled: false },
  ];

  return (
    <div className="map-layer-toggle" data-testid="layer-toggle-panel">
      <div className="map-layer-toggle-header">
        <Layers size={14} />
        <span>{isArabic ? 'الطبقات' : 'Layers'}</span>
      </div>
      {items.map(item => (
        <label
          key={item.key}
          className={`map-layer-item ${!item.enabled ? 'map-layer-item--disabled' : ''}`}
          data-testid={`layer-toggle-${item.key}`}
        >
          <span className="map-layer-dot" style={{ background: item.color, opacity: layers[item.key] ? 1 : 0.3 }} />
          <span className="map-layer-name">{item.label}</span>
          <input
            type="checkbox"
            checked={layers[item.key]}
            disabled={!item.enabled}
            onChange={() => item.enabled && onChange({ ...layers, [item.key]: !layers[item.key] })}
            className="map-layer-checkbox"
          />
        </label>
      ))}
    </div>
  );
};

export default MapLayerToggle;
